import { fmtBRL } from "@/lib/api";
import { CalendarRange } from "lucide-react";

const fmtDay = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" });

export const WeekSummary = ({ week }) => {
  const pct = week.forecast_amount ? Math.min(100, Math.round((100 * week.received_amount) / week.forecast_amount)) : 0;
  const rows = [
    ["Previsto na semana", fmtBRL(week.forecast_amount), "text-sky-300", "week-forecast-amount"],
    ["Recebido na semana", fmtBRL(week.received_amount), "text-emerald-300", "week-received-amount"],
    ["Logins vencendo", week.forecast_count.toLocaleString("pt-BR"), "text-slate-100", "week-forecast-count"],
    ["Ticket médio", fmtBRL(week.forecast_count ? week.forecast_amount / week.forecast_count : 0), "text-slate-100", "week-ticket"],
  ];
  return (
    <div data-testid="week-summary-card" className="lg:col-span-5 rounded-2xl border border-[#1F293D] bg-[#111827] p-6 fade-up" style={{ animationDelay: "80ms" }}>
      <div className="flex items-center justify-between">
        <h3 className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-slate-200">
          <CalendarRange className="h-4 w-4 text-sky-400" /> Semana corrente
        </h3>
        <span className="font-mono text-xs text-slate-500">{fmtDay(week.start)} – {fmtDay(week.end)}</span>
      </div>
      <div className="mt-5 space-y-3">
        {rows.map(([label, value, color, testid]) => (
          <div key={label} className="flex items-center justify-between border-b border-[#1F293D]/70 pb-3 last:border-0">
            <span className="text-sm text-slate-400">{label}</span>
            <span data-testid={testid} className={`font-mono text-lg font-bold ${color}`}>{value}</span>
          </div>
        ))}
      </div>
      <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-[#0F141F]">
        <div className="h-full rounded-full bg-emerald-400 transition-[width] duration-700" style={{ width: `${pct}%` }} />
      </div>
      <p className="mt-2 text-xs text-slate-500">{pct}% do previsto da semana já recebido</p>
    </div>
  );
};
